export default "__VITE_ASSET__DSpCVzsz__"